import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Icon } from "components";
import { Button } from "ui/components/button";
import { useSidebar } from "ui/components/sidebar";
import { ShimmerEffect } from "components/shimmer";
import IntegrationSidebarLayout from "../../components/sidebar-layout";
import { fetchRepo, repoNameFromUrl } from "./api";
import RepoLabel from "../repo-label";

export const repoQuery = (repo_id) => ({
  queryKey: ["integrations-github-repo", repo_id],
  queryFn: () => fetchRepo({ id: repo_id }),
  enabled: !!repo_id,
});

function RepoHeader({ repoId }) {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";
  const { data: repo, isLoading } = useQuery(repoQuery(repoId));

  console.log("repo",repo);
  

  const back = (
    <Button asChild size="icon" variant="ghost" className="size-7 shrink-0" title="Back to repositories">
      <Link to="/integrations/github/repositories">
        <Icon icon="lucide:arrow-left" className="size-4" />
      </Link>
    </Button>
  );

  if (isCollapsed) return <div className="flex justify-center p-2">{back}</div>;

  return (
    <div className="flex items-center gap-2 p-3 border-b">
      {back}
      <div className="flex-1 min-w-0">
        {isLoading ? (
          <ShimmerEffect className="h-5 w-32" />
        ) : (
          <div className="flex items-center gap-2 min-w-0">
            <h2 className="font-semibold truncate" title={repo?.suffix}>
              {repoNameFromUrl(repo?.repository_url)}
            </h2>
            <RepoLabel visibility={repo?.visibility} flag={repo?.flag} className="shrink-0" />
          </div>
        )}
      </div>
      {repo?.repository_url && (
        <Button asChild size="icon" variant="ghost" className="size-7 shrink-0" title="Open on GitHub">
          <a href={repo.repository_url} target="_blank" rel="noreferrer">
            <Icon icon="lucide:external-link" className="size-4" />
          </a>
        </Button>
      )}
    </div>
  );
}

// /integrations/github/repositories/:repo_id/*: repo header + Branches tab.
export default function GithubRepoLayout() {
  const { repo_id } = useParams();
  return (
    <IntegrationSidebarLayout
      name="integrations-github-repo"
      header={<RepoHeader repoId={repo_id} />}
      items={[
        {
          title: "Branches",
          icon: "lucide:git-branch",
          url: `/integrations/github/repositories/${repo_id}/branches`,
        },
        {
          title: "People",
          icon: "lucide:users",
          url: `/integrations/github/repositories/${repo_id}/people`,
        },
      ]}
    />
  );
}
